export const GET_TRIP_EXPENSES = 'GET_TRIP_EXPENSES';
export const GET_TRIP_EXPENSE = 'GET_TRIP_EXPENSE';
export const FLAG_GETTING_TRIP_EXPENSES = 'FLAG_GETTING_TRIP_EXPENSES';
export const FLAG_TRIP_EXPENSE_ACTIVITY = 'FLAG_TRIP_EXPENSE_ACTIVITY';
export const CLEAR_TRIP_EXPENSE = 'CLEAR_TRIP_EXPENSE';
export const CLEAR_TRIP_EXPENSES = 'CLEAR_TRIP_EXPENSES';
